const COOKIE_EXPIRATION_DAYS = 7; // Default expiration in days
const store = window.sessionStorage;

// Session Storage utilities
export const getStorage = key => JSON.parse(store.getItem(key));

export const setStorage = (key, value) => store.setItem(key, JSON.stringify(value));

export const removeStorage = key => store.removeItem(key);

export const clearAllStorage = () => store.clear();

export const hasStorage = key => {
    const item = getStorage(key);
    return !!item;
}

// "Cookie" utilities — kept the same name/signature as the original document.cookie-backed
// implementation so every call site (login flows, request interceptor, role switching, etc.)
// needed no changes, but now backed by sessionStorage instead of a real browser cookie. A real
// cookie is auto-attached by the browser to every request to the origin, including static
// asset requests (JS/CSS/images/favicon) — that's what was tripping the WAF's SQLi rules on
// the JWT/JSON content of the userData and selectedRole values. sessionStorage is never sent
// over HTTP automatically, only read and forwarded explicitly by this app's own code (e.g.
// into the Authorization header), so it carries none of that WAF exposure. Expiry is emulated
// with an explicit timestamp since sessionStorage itself has no per-item TTL.
const cookieStoreKey = name => `__cookie:${name}`;

export const setCookie = (name, value, expiryDate) => {
    let expires;
    if (expiryDate) {
        expires = new Date(expiryDate);
    } else {
        expires = new Date();
        expires.setTime(expires.getTime() + (COOKIE_EXPIRATION_DAYS * 24 * 60 * 60 * 1000)); // Add 7 days
    }
    const record = { value, expires: expires.getTime() };
    try {
        window.sessionStorage.setItem(cookieStoreKey(name), JSON.stringify(record));
    } catch (e) {
        // sessionStorage can throw in private-browsing/storage-restricted contexts; fail silently
        // to match the previous document.cookie behavior, which never threw either.
    }
};

export const getCookie = (name) => {
    let raw;
    try {
        raw = window.sessionStorage.getItem(cookieStoreKey(name));
    } catch (e) {
        return null;
    }
    if (!raw) return null;

    try {
        const record = JSON.parse(raw);
        if (record.expires && Date.now() > record.expires) {
            window.sessionStorage.removeItem(cookieStoreKey(name));
            return null;
        }
        return record.value;
    } catch (e) {
        return null;
    }
};

export const deleteCookie = (name) => {
    try {
        window.sessionStorage.removeItem(cookieStoreKey(name));
    } catch (e) {
        // no-op, matching previous behavior
    }
};